export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ../~/@ant-design/icons-react/es/index.js
// module id = 297
// module chunks = 0